import { apiRequest } from './client.ts';

export interface RecapMember {
  user_id: string;
  username: string;
  /** CENTIPUNTOS (D6) del PERIODO, no el total de la liga. */
  points_centi: number;
  winner_hits: number;
  exact_hits: number;
  settled_matches: number;
}

export interface RecapStreak {
  user_id: string;
  username: string;
  tipo: 'alcanzado' | 'roto';
  longitud: number;
}

export interface Recap {
  league: { id: string; name: string };
  window: { days: number; from: string; to: string };
  matches: Array<{
    match_id: number;
    kickoff_time: string;
    home_team: string;
    away_team: string;
    home_score: number;
    away_score: number;
    is_knockout: boolean;
  }>;
  members: RecapMember[];
  highlights: {
    best: RecapMember[];
    worst: RecapMember[];
    streaks: RecapStreak[];
  };
  /**
   * El texto ya redactado en francés, listo para pegar en WhatsApp.
   *
   * Lo genera el BACKEND a propósito: es contenido, no interfaz, y es lo que necesitará
   * el recap programado de la Tarea 9, que no pasa por React. Aquí solo se pinta.
   */
  text: string;
}

export function getRecap(leagueId: string, days?: number): Promise<Recap> {
  const query = days === undefined ? '' : `?days=${days}`;
  return apiRequest(`/leagues/${leagueId}/recap${query}`);
}
